import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection, LeadingTitle } from "@components";
import "./ListBusinessSolution.scss";
import { BusinessSolutionAPI, ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import HeaderSection from "../../../common/components/Header/HeaderSection";
import LandingCardBox from "../../../common/components/LandingCardBox";
import { TitleComponent } from "../../../common/components/TitleComponent";
import { useParams } from "react-router-dom";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const ListBusinessSolutionContainer = styled.div`
  background-color: #fff;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const ListBusinessSolution = function () {
  const { t } = useTranslation();
  const [data, setdata] = useState([]);
  const [shortDesc, setShortDesc] = useState({});
  const [isLoading, setisLoading] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    setisLoading(true);
    loadShortDescData();
  }, []);

  const loadData = async function () {
    const { data } = await BusinessSolutionAPI(`?cat=${id}`);
    setdata(data.data);
  };

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: id });
    setShortDesc(data.data ? data.data[0] : "");
    loadData();
    setisLoading(false);
  };
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <HeaderSection
          title={shortDesc.title}
          group={t("your_business_solution")}
          description={shortDesc.description}
          banner={shortDesc.banner}
        />
      </Container>

      <ListBusinessSolutionContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row">
                <div className="col-12">
                  <h4>
                    {t("pilih_jenis_program")}
                    {id === "umkm" ? "UMKM" : "Komersial"}
                  </h4>
                </div>
              </div>
              <div className="row mt-2">
                {data.map((item, index) => {
                  return (
                    <div className="col-lg-4" key={index}>
                      <Desktop>
                        <LandingCardBox
                          title={item.title}
                          //description={item.description}
                          image={item.imageBannerDesktop}
                          redirectUrl={"/business-solution/detail/" + item.id}
                        />
                      </Desktop>
                      <Mobile>
                        <LandingCardBox
                          title={item.title}
                          //description={item.description}
                          image={item.imageBannerMobile}
                          redirectUrl={"/business-solution/detail/" + item.id}
                        />
                      </Mobile>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </ListBusinessSolutionContainer>
      <FooterSection currentPage={id === 'umkm' ? t("UMKM") : t("komersial")} />
    </div>
  );
};

export default ListBusinessSolution;
